import { getEventCategories, getListOfCelebrations, getListOfEvents } from 'services/axios/events'

// Action type
const actions = {
  FETCH_EVENT_DATA: 'FETCH_EVENT_DATA',
  FETCH_CELEBRATION_DATA: 'FETCH_CELEBRATION_DATA',
  FETCH_EVENT_CATEGORIES: 'FETCH_EVENT_CATEGORIES',
  EVENT_HANDLE_PAGINATION: 'HOLIDAY_HANDLE_PAGINATION',
}

// Action creaters
export const fetchEventsData = () => {
  return async (dispatch) => {
    const response = await getListOfEvents()
    dispatch({ type: actions.FETCH_EVENT_DATA, payload: response?.data?.eventData })
  }
}

export const fetchCelebrationsData = (params) => {
  return async (dispatch) => {
    const response = await getListOfCelebrations(params)
    dispatch({
      type: actions.FETCH_CELEBRATION_DATA,
      payload: response?.data?.celebrationData || [],
    })
  }
}

// Master data for the Add/Edit Event category picker. Served already filtered
// of the reserved values, so a birthday can never be offered as a choice.
export const fetchEventCategories = () => {
  return async (dispatch) => {
    const response = await getEventCategories()
    dispatch({
      type: actions.FETCH_EVENT_CATEGORIES,
      payload: response?.data?.categoryData || [],
    })
  }
}

export default actions
